import { WebsiteSliderTypeEnum } from '@onArte/shared/database/enums';
import { AttachmentInterface, SliderButtonSettingsInterface } from '@onArte/shared/interfaces/common';

export abstract class AbstractSliderDTO {
  constructor(
    public id: number,
    public type: WebsiteSliderTypeEnum,
    public image: AttachmentInterface,
    public header: string,
    public buttonSettings: SliderButtonSettingsInterface | null,
    public secondButtonSettings: SliderButtonSettingsInterface | null,
    public description: string | null,
  ) {}
}
